import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const track = (event, meta = {}) => {
  axios.post(`${API}/analytics/event`, { event, meta }).catch(() => {});
};

export const getConfig = () =>
  axios.get(`${API}/config`).then((r) => r.data).catch(() => ({}));

export const startCheckout = async () => {
  track("booking_start", { source: "direct" });
  const { data } = await axios.post(`${API}/payments/checkout-direct`, {
    origin_url: window.location.origin,
  });
  window.location.href = data.checkout_url;
};
